import { Component, OnInit } from '@angular/core';
import {LangChange} from "../../../../lang-change";
import {Principal} from "../../../../common/services/principal";
import {Router, ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Language} from "../../../../common/models/language";

@Component({
  selector: 'app-enroll-main',
  templateUrl: './enroll-main.component.html',
  styleUrls: ['./enroll-main.component.scss']
})
export class EnrollMainComponent  extends LangChange implements OnInit {

  userDto: any;

  constructor(private _route: Router,
              private route: ActivatedRoute,
              public _translateService: TranslateService,
              private _principal: Principal) {
    super(_translateService);
  }

  ngOnInit() {
    console.log('EnrollMainComponent');
    this.userDto = this._principal.getUser();
  }

  onLangChange(language: Language): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-main/enroll-main.component.ts